export default __webpack_public_path__ + "1ada7f72910b32e1306db70ad2e5f96d.png";